import React from "react";

export default function Pagination({ page, totalPages, onPageChange }) {
  return (
    <div className="flex items-center justify-between w-full px-3 py-2 sm:px-4 border-t border-slate-100 bg-white rounded-b-xl">
      <div className="flex flex-1 justify-between sm:hidden">
        <button 
          onClick={() => onPageChange(Math.max(1, page - 1))} 
          disabled={page === 1} 
          className="btn-secondary px-3 py-1.5 text-xs disabled:opacity-50"
        >
          Previous
        </button>
        <button 
          onClick={() => onPageChange(Math.min(totalPages, page + 1))} 
          disabled={page === totalPages} 
          className="btn-secondary px-3 py-1.5 text-xs disabled:opacity-50"
        >
          Next
        </button>
      </div>
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-[11px] text-slate-500 font-medium">
            Page <span className="font-bold text-brand-dark">{page}</span> of <span className="font-bold text-brand-dark">{totalPages}</span>
          </p>
        </div>
        <div>
          <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
            <button 
              onClick={() => onPageChange(Math.max(1, page - 1))} 
              disabled={page === 1} 
              className="relative inline-flex items-center rounded-l-md px-1.5 py-1.5 text-slate-400 ring-1 ring-inset ring-slate-200 hover:bg-slate-50 focus:z-20 focus:outline-offset-0 disabled:opacity-30"
            >
              <span className="sr-only">Previous</span>
              <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd" />
              </svg>
            </button>
            <div className="flex items-center px-3 text-xs font-bold text-brand-blue ring-1 ring-inset ring-slate-200">{page}</div>
            <button 
              onClick={() => onPageChange(Math.min(totalPages, page + 1))} 
              disabled={page === totalPages} 
              className="relative inline-flex items-center rounded-r-md px-1.5 py-1.5 text-slate-400 ring-1 ring-inset ring-slate-200 hover:bg-slate-50 focus:z-20 focus:outline-offset-0 disabled:opacity-30"
            >
              <span className="sr-only">Next</span>
              <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
              </svg>
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
}

Pagination.displayName = 'Pagination';
export { Pagination };
